type TooltipProps = {
  text: string | null;
  children: any;
  _className?: string;
  _position?:
    | "right-0"
    | "left-0"
    | "right-2/6"
    | "bottom-0"
    | "left-2/6"
    | "bottom-1"
    | "bottom-4"
    | "top-6"
    | "top-6 right-0"
    | "top-[-25px] left-2/6 -translate-x-[-5%]";
};

function Tooltip(props: TooltipProps) {
  const { text, children, _className, _position } = props;

  return (
    <div className="relative group z-[9999]">
      {children}
      {text && (
        <div
          className={`absolute hidden group-hover:flex ${_position} z-[9999]`}
        >
          <p
            className={`text-justify w-fit rounded-md max-w-96 whitespace-normal px-2 py-1 text-xs text-black overflow-visible bg-gray-200 shadow-lg ${_className}`}
          >
            {text}
          </p>
        </div>
      )}
    </div>
  );
}

export default Tooltip;

export function toTitleCaseLabel(key: string): string {
  return key
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2") // insert space before capital letters
    .replace(/_/g, " ") // replace underscores with space
    .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize first letter of each word
}
